import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import TableText from "components/TableText";
import {useSelector} from "react-redux";
import {Typography} from "@material-ui/core";
import * as api from 'lib/api';
import API_RESOURCES from 'lib/api/resources';

const TableUserRole = ({item}) => {
  const [clientCount, setClientCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadClientRoles();
  }, [item._id]);

  const loadClientRoles = async () => {
    try {
      setLoading(true);
      if (item.roles && item.roles.includes('admin')) {
        setClientCount(-1);
        return;
      }
      const response = await api.get(`${API_RESOURCES.USER_CLIENT_ROLES}/by-user/${item._id}`);
      const assignments = response.data?.assignments || [];
      const uniqueClients = new Set(assignments.map(a => a.client._id));
      setClientCount(uniqueClients.size);
    } catch (error) {
      console.error('Error loading client roles:', error);
      setClientCount(0);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Typography>-</Typography>;
  }

  const displayText = clientCount === -1 ? 'admin' : `${clientCount} client(s)`;

  return (
    <TableText
      accessor={"role"}
      item={{ role: displayText }}
    />
  );
};

TableUserRole.propTypes = {
  item: PropTypes.object.isRequired
};

export default TableUserRole;